import React from "react";
import { connectMetaMaskWallet } from "../../../wallet/metamask";
import { connectWalletConnect } from "../../../wallet/walletconnect";
import { metaMask } from "../../../wallet/metamask";
import { walletConnect } from "../../../wallet/walletconnect";

const ModalWalletItem = ({ id, name, setWalletChoice, isModalOpen, setIsModalOpen }) => {
	return (
		<div
			className="w-10/12 gradient-reverse py-4 rounded-lg p-2 cursor-pointer drop-shadow-lg transition-all hover:gradient text-center"
			onClick={() => {
				if (id === "metamask") {
                    setWalletChoice("metamask");
					connectMetaMaskWallet(metaMask);
				} else {
                    setWalletChoice("walletconnect");
					connectWalletConnect(walletConnect);
				}
				setIsModalOpen(!isModalOpen);
			}}>
			{name}
		</div>
	);
};

export default ModalWalletItem;
